import { FC, useState } from 'react';

import {
    Banner,
    Button,
    ButtonGroup,
    Drawer,
    Icon,
    Input,
    Stack,
} from '@servicetitan/design-system';

import { ApiGroup } from '../../api/app.api';
import { ApiScopeTable } from './api-scope-table';

export interface ApiScopesDrawerProps {
    apiGroup: ApiGroup;
    enabledAuthScopes: Set<string>;
    hasBlockedAuthScopes: boolean;
    selectedAuthScopes: Set<string>;
    onSubmit: () => void;
    onCancel: () => void;
}

export const ApiScopesDrawer: FC<ApiScopesDrawerProps> = ({
    apiGroup,
    enabledAuthScopes,
    hasBlockedAuthScopes,
    selectedAuthScopes,
    onSubmit,
    onCancel,
}) => {
    const [blockedAuthScopesBannerVisible, setBlockedAuthScopesBannerVisible] =
        useState(hasBlockedAuthScopes);
    const [searchText, setSearchText] = useState('');

    return (
        <Drawer
            backdrop
            width="m"
            header="API Scopes"
            footer={
                <ButtonGroup>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button primary onClick={onSubmit}>
                        Done
                    </Button>
                </ButtonGroup>
            }
            open
            onClose={onCancel}
        >
            <Stack direction="column" spacing={3} className="h-100">
                {blockedAuthScopesBannerVisible && (
                    <Banner
                        status="warning"
                        icon
                        title="Disabled scopes are not available for use by your organization."
                        onClose={() => {
                            setBlockedAuthScopesBannerVisible(false);
                        }}
                    />
                )}
                <Input
                    placeholder="Search"
                    shortLabel={<Icon name="search" />}
                    value={searchText}
                    onChange={(_event, data) => {
                        setSearchText(data.value);
                    }}
                />
                <Stack.Item fill className="min-h-0">
                    <ApiScopeTable
                        apiGroup={apiGroup}
                        enabledAuthScopes={enabledAuthScopes}
                        selectedAuthScopes={selectedAuthScopes}
                        searchText={searchText}
                    />
                </Stack.Item>
            </Stack>
        </Drawer>
    );
};
ApiScopesDrawer.displayName = 'ApiScopesDrawer';
